import { FunctionComponent } from "react";
import { RestoreFromBOMStore, useRestoreFromBOMStore } from "./Restore/RestoreFromBOMStore";
import { observer } from "mobx-react-lite";
import { Checkbox, GridColumn, SearchPlaceholder, SearchTextField, Text } from "designSystem/index";
import RadioGroup from "designSystem/components/radio/RadioGroup";
import React from "react";
import { Divider } from "@mui/material";
import CheckboxTree, { CheckboxTreeNode, CheckboxTreeStore } from "designSystem/components/checkbox/CheckboxTree";
import { GridColumnProps } from "designSystem/components/grid/GridContainer";

export interface RestoreSettingsFormProps extends GridColumnProps  {
	store?: RestoreFromBOMStore;
}

export const RestoreSettingsForm: FunctionComponent<RestoreSettingsFormProps> = observer((props) => {
	const store = props.store || useRestoreFromBOMStore();
	const RESTORE_FROM_STYLE_BOM_ACTION: string = "RestoreFromStyleBOM";
	
	const {
		actionId,
		actionResource, 
		resources, 
		searchText, 
		filteredAddItems, 
		addUniqueIds, 
		filteredDeleteItems, 
		restoreAllPlacements,
		overrideAttributes,
		placementOptions,
		attributeOptions,
		onChangeAttributeOptions,
		onChangeSearchTextField, 
		onChangePlacementOptions, 
		onCreateRevision,
		updateUniqueIds, 
		filteredUpdateItems, 
		hasRevision, 
		createRevision,
		placementSettingsLabel,
		attributeSettingsLabel,
		hasOverrideAttributesOption,
	} = store;

	const { sx } = props;

	return (
		<GridColumn
			scroll
			spacing={4}
			sx={sx}
		>
 			<Text res={actionResource(resources.configureRestoreSettings)} />
			<Text res={actionResource(resources.restoreSettings)} variant="h6" />
			<RadioGroup
				name={placementSettingsLabel}
				onChange={onChangePlacementOptions}
				options={placementOptions}
				value={restoreAllPlacements}
			/>
			{hasOverrideAttributesOption &&
				(
					<RadioGroup
						name={attributeSettingsLabel}
						onChange={onChangeAttributeOptions}
						options={attributeOptions}
						value={overrideAttributes}
					/>
				)}
			{hasRevision && 
				(
					<Checkbox
						checked = {createRevision}
						labelProps={{
							res: "CreateNewRevision",
						}}
						onChange={onCreateRevision}
					/>
				)}
			<Divider />
			<SearchTextField
				fullWidth
				onChange={onChangeSearchTextField}
				placeholderRes="Search"
				value={searchText}
			/>
			{filteredDeleteItems?.hasChildren && 
				(
					<PlacementCheckBoxTree
						headingTextRes={actionResource(resources.placementsToDelete)}
						items={[filteredDeleteItems]}
						uniqueIds={[filteredDeleteItems.uniqueId]}
					/>
				)}
			{filteredUpdateItems?.length > 0 && 
				(
					<PlacementCheckBoxTree
						headingTextRes={actionResource(resources.placementsOnStyleBOM)}
						items={filteredUpdateItems}
						uniqueIds={updateUniqueIds}
					/>
				)}
			{restoreAllPlacements && filteredAddItems?.length > 0 &&
				(
					<PlacementCheckBoxTree
						headingTextRes={actionResource(resources.placementsToAdd)}	
						items={filteredAddItems}
						uniqueIds={addUniqueIds}
					/>
				)}
			{!filteredDeleteItems?.hasChildren && filteredUpdateItems?.length === 0 && ((restoreAllPlacements && filteredAddItems?.length === 0) || !restoreAllPlacements) &&
				(
					<SearchPlaceholder 
						titleProps={{ res: "SEARCH_NO_RESULTS" }}
					/>
				)}
		</GridColumn>
	);
});

const PlacementCheckBoxTree: FunctionComponent<{items: CheckboxTreeNode[]; uniqueIds: string[]; headingTextRes: string}> =(props) => {
	const {
		items,
		headingTextRes,
		uniqueIds,
	} = props;
	const store = new CheckboxTreeStore(items);
	return (
		<GridColumn spacing={4}>
			<Text res={headingTextRes} variant="h6" />
			<CheckboxTree
				defaultExpanded={uniqueIds}
				displayCounts
				store={store}
			/>
		</GridColumn>
	);
};